import {
  er,
  ke
} from "./chunk.CV2QA46K.js";
import {
  jb_button_primary_css_default
} from "./chunk.KJWCZTWO.js";
import {
  ae
} from "./chunk.6PQ7B7BC.js";
import {
  Linkable
} from "./chunk.SUDKOARH.js";
import {
  Rt
} from "./chunk.DS2KVX5X.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  r
} from "./chunk.NBIYIO67.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  ButtonElement
} from "./chunk.DIUVUHDO.js";
import {
  n
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-button-primary/jb-button-primary.ts
var JbButtonPrimary = class extends Initiable(ButtonElement(Linkable(r))) {
  render() {
    const classes = { inactive: !!this.inactive, hover: !!this.forceHover, inverted: !!this.inverted };
    const tag = this.link?.href ? er`a data-linkable` : er`button`;
    return ke`<${tag} class=${Rt(classes)} ?disabled=${this.inactive} data-fly-tweak="3,0,0,0"><slot>${this.text ? ae(this.text) : D}</slot></${tag}>`;
  }
};
JbButtonPrimary.styles = [reset_css_default, jb_button_primary_css_default];
JbButtonPrimary.shadowRootOptions = { ...r.shadowRootOptions, delegatesFocus: true };
__decorateClass([
  n({ type: Boolean })
], JbButtonPrimary.prototype, "forceHover", 2);
__decorateClass([
  n({ type: Boolean })
], JbButtonPrimary.prototype, "inactive", 2);
__decorateClass([
  n({ type: Boolean })
], JbButtonPrimary.prototype, "inverted", 2);
__decorateClass([
  n({ type: Object })
], JbButtonPrimary.prototype, "link", 2);
__decorateClass([
  n()
], JbButtonPrimary.prototype, "name", 2);
__decorateClass([
  n()
], JbButtonPrimary.prototype, "text", 2);
JbButtonPrimary = __decorateClass([
  customElement("jb-button-primary")
], JbButtonPrimary);

export {
  JbButtonPrimary
};
